export const inputRegex = /^\s*([-+*])\s$/;
/**
 * 工具弹窗中默认的列表样式，默认三个英文的样式 circle、disc、square ，其他样式需要添加对应的 unicode 码
 * unicode 符号表：
 * http://unicode.org/charts/PDF/U2700.pdf
 * https://symbl.cc/en/unicode/blocks/general-punctuation/#subblock-2020
 */
export const defaultStyleListTypes = [
    ['circle', 'disc', 'square'],
    ['\\27A3', '\\2713', '\\2727'],
];
/**
 * circle (空心圆) disc（实心圆） square （实心方块） 对应的 unicode 映射
 * https://css-tricks.com/everything-you-need-to-know-about-the-gap-after-the-list-marker/
 */
export const listStyleTypeMap = {
    circle: '\\25EF',
    disc: '\\25CF',
    square: '\\25A0',
};
export const bulletListName = 'bulletList';
//# sourceMappingURL=conf.js.map